const actions = {
  SET_STATE: 'fyntiqWallet/SET_STATE',
  FETCH_WALLET_STATS: 'fyntiqWallet/FETCH_WALLET_STATS',
  FETCH_WALLET_SIGNUPS: 'fyntiqWallet/FETCH_WALLET_SIGNUPS',
  FETCH_ALL_WALLETS: 'fyntiqWallet/FETCH_ALL_WALLETS',
  FETCH_ALL_TRANSACTIONS: 'fyntiqWallet/FETCH_ALL_TRANSACTIONS',
}

export default actions
